import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 862B14E6-BA7A-4736-8047-1C836B2F4EC1
 * name check-underline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-underline.svg
 * tags
 */
export const CheckUnderlineIcon = createSvgIcon(<><path d="M21,5L9,17L3.5,11.5L4.91,10.09L9,14.17L19.59,3.59L21,5M3,21V19H21V21H3Z" /></>, 'CheckUnderlineIcon');
export default CheckUnderlineIcon